import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import {comnEnvs, comnUtils} from "@/comn/utils";

import { Button, Layout, Group, Page } from "@/comn/components";
import { useFetch, useForm, useStore, useToast, useResource, usePage, useAuth, useModal } from "@/comn/hooks";
import { APIS, SF_USR_INFO, URLS } from "@/tz/go/egaz/osci/ptl/usr/info/services/OsciMyInfoService";
import { comnUtils } from "@/comn/utils";
import { usePwdAuth } from "@/comn/hooks/usePwdAuth";

/*
 * Chnage My Information Update
 * !== 나의정보수정  ==!
 */
export const OSCI0103003S = (): JSX.Element => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const auth = useAuth();
    const { usrIdntfId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const [changeRppnYn, setRppnYn] = useState<boolean>(false);

    useResource({
        defaultSchema: [{ area: "cntyCd" }, { area: "orgCd" }, { area: "orgUsr" }, { area: "cstmCd" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // My Information !== 나의정보 ==!
        usrInfo: useForm({
            defaultSchema: SF_USR_INFO,
            defaultValues: { ...pgeStore?.form },
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Search My Information !==  나의정보조회 ==!
        getOrgUsrInfo: useFetch({
            api: (data) => APIS.getMyInfo(auth.get("usrIdntfId")),
            enabled: !!auth.get("usrIdntfId"),
            onSuccess: (data) => {
                const myInfo = data.myInfo.content;
                form.usrInfo.setValues(myInfo);

                if (form.usrInfo.getValue("orgRppnYn") == "N") {
                    form.usrInfo.setEditable("orgRppnYn", true);
                } else {
                    form.usrInfo.setEditable("orgRppnYn", true);
                }
            },
            onError: (error) => {},
            showToast: true,
        }),

        // Update My Information !== 나의정보 수정 ==!
        updateMyInfo: useFetch({
            api: (info: any) => APIS.updateMyInfo(info),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.osc.00070" }); // Successfully updated. !== 정상적으로 수정되었습니다.==!
                navigate(`${URLS.osci0103002q}?menuId=${menuId}`);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00039" }), // Failed to update. !== 수정이 실패하였습니다.==!
        }),
    };
    const render = {};

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Click Update Button !== 수정 버튼 클릭 ==!
        onUpdateBtnClick: form.usrInfo.handleSubmit(
            () => {
                // if (CSTM_OFCE_CD_RQRD_ARR.includes(form.usrInfo.getValue("orgCd"))) {
                //     if (comnUtils.isEmpty(form.usrInfo.getValue("cstmOfceCd"))) {
                //         form.usrInfo.setError("cstmOfceCd", {
                //             message: "msg.osc.00013", // Mandatory fields !== 필수 입력 필드 ==!
                //             type: "error",
                //         });
                //         return;
                //     }
                // }

                modal.openModal({
                    content: "msg.osc.00064", // Confirm update? !== 수정하시겠습니까? ==!
                    onConfirm: () => fetch.updateMyInfo.fetch(form.usrInfo.getValues()),
                });
            },
            () => toast.showToast({ type: "warning", content: "msg.osc.00003" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
        ),

        ppupYnChange: (changeRppnYn: any) => {
            // const asIsRppnYn = form.usrInfo.getValue("orgRppnYn");

            if (changeRppnYn == "N") {
                setRppnYn(true);
            } else {
                if (!comnUtils.isEmpty(form.usrInfo.getValue("nextRppnXtrnUsrUuid"))) {
                    form.usrInfo.setValue("nextRppnXtrnUsrUuid", null);
                }
                setRppnYn(false);
            }
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getOrgUsrInfo.fetch();
        form.usrInfo.setEditable("psnTin", false);
        form.usrInfo.setEditable("orgCd", false);
        form.usrInfo.setEditable("usrNm", false);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.usrInfo.schema.psnTin} />
                            <Group.Control {...form.usrInfo.schema.orgCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.usrInfo.schema.usrNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.usrInfo.schema.orgRppnYn}
                                onChange={(value) => {
                                    handler.ppupYnChange(value);
                                }}
                            />
                            {/* <Group.Control {...form.usrInfo.schema.frgnrYn} /> */}
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.usrInfo.schema.aplcCntyCd} />
                            <Group.Control {...form.usrInfo.schema.usrMoblNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.usrInfo.schema.usrEmlAddr} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.usrInfo.schema.rsdtAddr} />
                        </Group.Row>
                        {/* <Group.Row>
                            <Group.Control {...form.usrInfo.schema.cstmOfceCd} />
                            <Group.Cell size={6}>{t("msg.osc.00249")}</Group.Cell>
                        </Group.Row> */}

                        {changeRppnYn && (
                            <>
                                <Group.Row>
                                    <Group.Control {...form.usrInfo.schema.nextRppnXtrnUsrUuid} />
                                </Group.Row>
                            </>
                        )}
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Right>
                            <Layout.Button
                                role={"save"}
                                onClick={() => {
                                    handler.onUpdateBtnClick();
                                }}
                            ></Layout.Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
        </Page>
    );
};
